import { createSlice } from "@reduxjs/toolkit";

const setupAccountSlice = createSlice({
  name: "setup",
  initialState: { value: true },
  reducers: {
    setupAccount: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setupAccount } = setupAccountSlice.actions;
export default setupAccountSlice.reducer;
